import { inject, observer } from 'mobx-react'
import { Box } from 'native-base'
import React from 'react'
import Loading from '../../components/basic/Loading'
import LocalizationContext from '../../context/LocalizationContext'
import { Camera } from 'expo-camera'
import QRScannerModal from '../../components/QRScannerModal'

function QRScannerScreen(props) {
    const { t } = React.useContext(LocalizationContext)
    const { navigation, route } = props
    const [isLoading, setIsLoading] = React.useState(true)

    React.useEffect(() => {
        const componentDidMount = async () => {
            try {
                const { status } = await Camera.requestPermissionsAsync()
                console.log(status)
            }
            catch (e) {
                console.log(e)
            }
            setIsLoading(false)
        }

        componentDidMount()
    }, [navigation])

    if (isLoading) {
        return <Loading />
    }

    const handleOnBarCodeScanned = async (v) => {
        if (v) {
            switch (route.params.type) {
                case 'MemberDetail':
                    return navigation.navigate('MemberDetail', { memberId: v })
                case 'UserCouponDetail':
                    return navigation.navigate('UserCouponDetail', { couponId: v })
                default:
                    break

            }
        }
    }

    return (
        <QRScannerModal
            onBarCodeScanned={(v) => handleOnBarCodeScanned(v)}
        />
    )
}

export default inject('memberStore')(observer(QRScannerScreen))